import { select, put } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import '../../../actions.js';
import { NEW_PRESCRIPTION, NEW_PRESCRIPTION_AND_UPLOAD } from '../../../constants.js';
import '../../../add-to-cart/selectors.js';
import '../../../bundles/selectors.js';
import '../../../bundles/reducer.js';
import { getSelectedFrame, getIsPrescriptionFormStepValid, getPrescriptionType } from '../../selectors.js';
import '../../reducer.js';
import '../../../products/selectors.js';
import '../../../products/reducer.js';
import { getFormValidationParameters } from '../../../configurations/selectors.js';
import { PrescriptionFormStepContainer } from '../../../../steps/PrescriptionFormStep/PrescriptionFormStepContainer.js';
import { isAxis, isCylinder } from '../../../../utils/parameter-type-guards.js';
import { getPrescription } from '../../../prescription/selectors.internal.js';
import { updatePrescriptionValue } from '../../../configurations/actions.js';

const prescriptionFormStepBase = {
    *onNext () {
        const formParameters = yield select(getFormValidationParameters);
        var ref;
        const optionalParams = (ref = formParameters === null || formParameters === void 0 ? void 0 : formParameters.filter((param)=>param.isOptional
        )) !== null && ref !== void 0 ? ref : [];
        const prescription = yield select(getPrescription);
        const frame = yield select(getSelectedFrame);
        if (!frame) {
            return new Error(`No frame found!`);
        }
        /**
     * For optional parameters, if we received no values for them,
     * we default their values to 0.
     * If these fields have no values (e.g. undefined), users won't be able
     * to add configurations to their cart.
     * TODO: Remove this default zero behavior after CXCD-9513 is implemented (https://jira.grandvision.global/browse/CXCD-9513)
     */ for (const param1 of optionalParams){
            if (isAxis(param1) || isCylinder(param1)) {
                const leftValue = prescription.left[param1.name];
                const rightValue = prescription.right[param1.name];
                if (!leftValue) {
                    yield put(updatePrescriptionValue({
                        side: 'left',
                        frameSku: frame.sku,
                        parameter: param1.name,
                        value: 0
                    }));
                }
                if (!rightValue) {
                    yield put(updatePrescriptionValue({
                        side: 'right',
                        frameSku: frame.sku,
                        parameter: param1.name,
                        value: 0
                    }));
                }
            }
        }
        const isValid = yield select(getIsPrescriptionFormStepValid);
        if (!isValid) {
            return new Error(`Need valid prescription data for unknown customer`);
        }
    },
    view: PrescriptionFormStepContainer,
    stepStatus: createSelector(getPrescriptionType, (prescriptionType)=>prescriptionType === NEW_PRESCRIPTION || prescriptionType === NEW_PRESCRIPTION_AND_UPLOAD ? 'sub-step' : 'hidden'
    )
};

export { prescriptionFormStepBase };
//# sourceMappingURL=prescription-form.js.map
